export default {
  sm: `
  내일을 위해,<br>오늘을 지키는<br class="hidden-md-up"> 기술 
  `,
};
